import servicio from '@/services/servicio-carrito';
const carrito = {     
methods: {      
    carritoModificarCantidad(codArticulo, cantidad, uuidAcceso) {               
        let cantidadCarrito = 0
            return this.carritoConsultarCantidad()
            .then(r=>{
                    cantidadCarrito = r.data;

                    let rutaOrigen= this.$route.path

                    servicio.modificarCantidad(codArticulo, cantidad, rutaOrigen, uuidAcceso)         
                        .then(p => {                                      
                            this.carritoConsultarCantidad().then(q=>{                           
                            if(cantidadCarrito == q.data && cantidad != 0) 
                                this.$emit("alertaActualizar");
                            else if(cantidad == 0)
                                this.$emit("alertaEliminar");
                            else
                                this.$emit("alertaAgregar");
                            })
                            return p;
                        })
                        .catch(e => {
                            return e;
                        })
                    return r;
                })         
    },
    carritoConsultarCantidad(){
        return servicio.consultarCantidadEnCarrito()
            .then(r=>{
            this.$emit("actualizarTotalCarrito",r.data)            
            return r;          
            }) 
            .catch(e=>{
            return e;
            })
        }   
    },  
}

export default carrito;